<template>
  <!-- app会员支付页中间页 -->
  <div class='vipMiddleDetail'>

  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {
      isIOS: '',
      urlId: '',
      urlType: '',
      vipType: '',
      vipId: '',
      token: '',
      hasHeader: ''
    }
  },
  created () {
    this.getToken()
    this.isIOS = this.$CONFIG.isIOS
    this.urlid = this.$route.query.id  // 1 会员卡id 2 直播间房间号
    this.urlType = this.$route.query.type //1 点击相应会员卡  2 从直播间进入
    this.hasHeader = this.$route.query.hasHeader
    this.getVipSend()
  },
  methods: {
    // 获取url上的信息
    getcommit (name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || ["", ""])[1].replace(/\+/g, "%20")
        ) || false
      );
    },
    // 获取token
    getToken () {
      if (this.$CONFIG.isVerify && this.isIOS) {
        this.token = '2a9cc326033c71cd67ac7caba01c2cd0*8028670'
      } else {
        this.token = this.getcommit('token') || ''
      }
    },
    async getVipSend () {
      let params = {
        id: this.urlid,
        type: this.urlType
      }
      let res = await this.$vipapi.getVipSend(params)
      console.log(res);
      this.vipType = res.data.data.type
      this.vipId = res.data.data.vipId
      console.log(this.type);
      // type 1 普通会员卡 2 球星会员卡 3 巅峰赛事包
      if (this.vipType == 1) {
        console.log('跳转普通会员卡');
        if (this.isIOS) {
          if (this.hasHeader) {
            console.log('ios有标题');
            this.$router.replace(`/vipiospay?id=${this.vipId}&type=1&token=${this.token}`)
          } else {
            console.log('ios无标题');
            this.$router.replace(`/vipiospay?id=${this.vipId}&type=1&token=${this.token}&noHeader=1`)
          }
        } else {
          if (this.hasHeader) {
            console.log('安卓有标题');
            this.$router.replace(`/vippay?id=${this.vipId}&type=1&token=${this.token}`)
          } else {
            console.log('安卓无标题');
            this.$router.replace(`/vippay?id=${this.vipId}&type=1&token=${this.token}&noHeader=1`)
          }
        }
      }
      if (this.vipType == 2) {
        console.log('跳转奥沙利文火星卡');
        this.$router.push(`/vipstar?id=${this.vipId}&type=1&token=${this.token}`)
      }
      if (this.vipType == 3) {
        console.log('跳转巅峰赛事包');
        this.$router.push(`/vipbag?id=${this.vipId}&type=1&token=${this.token}`)
      }
    },
    // 判断环境
    convertDomain (currDomain) {
      var localDomain = window.location.host
      var name = localDomain.split('.', 2)[0]
      var arr = name.split('-', 2)
      return arr.length > 1 ? arr[0] + '-' + currDomain : currDomain
    }
  },
}
</script>
<style lang='less' scoped>
.vipMiddleDetail {
}
</style>
